window.Products.HomeDecor.Pillow = function() {};
window.Products.HomeDecor.Pillow.inherits(window.Products.HomeDecor.HomeDecor);

window.Products.HomeDecor.Pillow.prototype.set3dProperties = function(modelViewer) {
	this.updateThreeTexture(modelViewer);
	modelViewer.object.children[0].scale.x = 5;
	modelViewer.object.children[0].scale.y = 5;
	modelViewer.object.children[0].scale.z = 5;
	modelViewer.object.children[0].position.y = -0.6;
	modelViewer.setFixedView('front');
	modelViewer.camera.position.z = 4;
};

window.Products.HomeDecor.Pillow.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[0].material.map = modelViewer.texture;
};